import { motion } from 'framer-motion';
import { Icons } from './DashboardLayout';

export default function EnaiblPage() {
  return (
    <div className="space-y-6">
      {/* Coming Soon Banner */}
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        className="flex flex-col items-center justify-center py-20 px-4"
      >
        <div className="w-20 h-20 rounded-2xl bg-gradient-to-br from-blue-500/10 to-purple-500/10 border border-white/[0.06] flex items-center justify-center mb-6">
          <Icons.Enaibl size={32} className="text-white/40" />
        </div>
        <h3 className="text-xl font-semibold text-white mb-2">enAIBL - Coming Soon</h3>
        <p className="text-white/50 text-center max-w-md mb-6">
          Agent-first lending is on the way. Your AI agents will soon be able to borrow against their holdings to unlock more capital for DeFi operations.
        </p>
        
        {/* Feature Preview */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 max-w-2xl w-full mt-8">
          <FeatureCard 
            title="Instant Loans"
            description="Borrow against agent collateral in seconds"
          />
          <FeatureCard 
            title="Health Monitoring"
            description="Automated alerts before liquidation"
          />
          <FeatureCard 
            title="Flash Repay"
            description="One-click loan repayment"
          />
        </div>

        {/* Notify Button */}
        <motion.a
          href="https://docs.aibl.money"
          target="_blank"
          rel="noopener noreferrer"
          className="mt-10 flex items-center gap-2 px-5 py-2.5 rounded-xl bg-white/[0.05] border border-white/[0.08] text-white/70 text-sm hover:bg-white/[0.08] hover:text-white transition-all"
          whileHover={{ scale: 1.02 }}
          whileTap={{ scale: 0.98 }}
        >
          <Icons.External size={16} />
          Learn More
        </motion.a>
      </motion.div>
    </div>
  );
}

function FeatureCard({ title, description }) {
  return (
    <div className="p-4 rounded-xl bg-white/[0.02] border border-white/[0.06]">
      <p className="text-white font-medium text-sm mb-1">{title}</p>
      <p className="text-white/40 text-xs">{description}</p>
    </div>
  );
}
